<template lang="html">
<div>
    <toolbar title="Company Accounts">
          <v-icon @click="loadCompanies()">refresh</v-icon>
    </toolbar>
  <v-layout column>

    <div class="pt-3">
      <v-card>
        <v-tabs v-model="tab" color="white" >
          <v-tabs-slider color="primary" />
          <v-tab key="verified">
            Verified ({{verifiedCompanies.length}})
          </v-tab>
          <v-tab key="unverified" >
            Unverified ({{unverifiedCompanies.length}})
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item key="verified">
            <company-table :companies="verifiedCompanies"></company-table>
          </v-tab-item>
          <v-tab-item key="unverified">
            <company-table :companies="unverifiedCompanies"></company-table>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </div>
  </v-layout>
</div>
</template>
<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import Toolbar from '@/components/Toolbar';
import CompanyTable from './CompanyTable';

export default {
  name: 'CompanyList',
  data: () => ({
    tab: 1,
    searchVerified: null,
    searchUnverified: null,
  }),
  components: {
    Toolbar,
    CompanyTable,
  },
  computed: {
    ...mapGetters('companies', [
      'companies',
      'getCompanyInfo',
    ]),
    verifiedCompanies() {
      return this.companies.filter(company => this.companyVerifiedDate(company));
    },
    unverifiedCompanies() {
      return this.companies.filter(company => _.isEmpty(this.companyVerifiedDate(company)));
    },
  },
  methods: {
    loadCompanies() {
      this.$store.dispatch('applications/addLoading', [
        this.$store.dispatch('companies/getCompanies'),
      ]);
    },
    companyStatus(company) {
      return _.get(company, 'accountStatus');
    },
    companyVerifiedDate(company) {
      return _.get(this.companyStatus(company), 'verified');
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Companies/CompanyList.vue